// build a reducer function from a map of action->functions
export default function buildReducer(defaultState, reducerMap) {
  return (state = defaultState, action) => {
    let reducer = reducerMap[action.type];
    if (typeof reducer === "function") {
      return reducer(state, action);
    }
    return state;
  };
}
